import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export interface ControlGroupSegmentProps extends React.HTMLAttributes<HTMLDivElement> {
  grow?: boolean;
}

const ControlGroupSegment = forwardRef<
  HTMLDivElement,
  ControlGroupSegmentProps
>(({ className, grow, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={twMerge(
      clsx(
        "control-group-segment relative flex min-w-0 items-stretch bg-white not-first:border-s not-first:border-gunmetal-200",
        "[&:focus-within:not(:has(>.control-group-action))]:z-10 [&:focus-within:not(:has(>.control-group-action))]:outline [&:focus-within:not(:has(>.control-group-action))]:outline-hunter-300 [&:focus-within:not(:has(>.control-group-action))]:ring-[3px] [&:focus-within:not(:has(>.control-group-action))]:ring-primary/25 [&:focus-within:not(:has(>.control-group-action))]:ring-offset-1 [&:focus-within:not(:has(>.control-group-action))]:ring-offset-transparent",
        "[&:has([aria-expanded=true]):not(:has(>.control-group-action))]:z-10 [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:outline [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:outline-hunter-300 [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:ring-[3px] [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:ring-primary/25 [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:ring-offset-1 [&:has([aria-expanded=true]):not(:has(>.control-group-action))]:ring-offset-transparent",
        "[&:has(>.control-group-action:focus-visible)]:z-10 [&:has(>.control-group-action:focus-visible)]:outline [&:has(>.control-group-action:focus-visible)]:outline-hunter-300 [&:has(>.control-group-action:focus-visible)]:ring-[3px] [&:has(>.control-group-action:focus-visible)]:ring-primary/25 [&:has(>.control-group-action:focus-visible)]:ring-offset-1 [&:has(>.control-group-action:focus-visible)]:ring-offset-transparent",
        grow && "flex-1",
      ),
      className,
    )}
  />
));

export default ControlGroupSegment;
